import React from "react"

import { gql, useQuery } from "urql"

import { AlertLevel } from "~tailwindui/types/enums"

import { AlertMessageBox, H2, WithLoadingIndicator } from "~tailwindui/Basics"

import InvitationCard from "./InvitationCard"

const OpenGenerationInvites = () => {
  const [result] = useQuery({ query })

  return (
    <>
      <AlertMessageBox level={AlertLevel.Info}>
        As students register and new groups are created, available groups will
        appear here.
      </AlertMessageBox>

      <WithLoadingIndicator result={result}>
        {({ data: { viewer } }) => (
          <>
            {viewer.recentlyGaveUpGroup ? (
              <AlertMessageBox level={AlertLevel.Warning}>
                You have given up a study group in the last 48 hours, so you are
                ineligible to accept new groups at this time.
              </AlertMessageBox>
            ) : null}

            <H2>Study Group Invites</H2>
            {viewer.openGenerationInvites.length > 0 ? (
              <div className="flex flex-wrap gap-10">
                {viewer.openGenerationInvites.map(invitation =>
                  invitation.availableStudyGroups.map(studyGroup => (
                    <InvitationCard
                      key={studyGroup.id}
                      invitation={invitation}
                      studyGroup={studyGroup}
                    />
                  ))
                )}
              </div>
            ) : (
              <span className="mb-8 text-lg italic">
                There are no open study group invitations at this time.
              </span>
            )}
          </>
        )}
      </WithLoadingIndicator>
    </>
  )
}

const query = gql`
  query StudyGroupTutorInvitations {
    viewer {
      recentlyGaveUpGroup
      openGenerationInvites {
        id
        availableStudyGroups {
          id
          name
          formattedDetails
          minTutorConsistencyRate
          maxSubsEstimate
          foreignLanguage {
            id
            name
          }
          organization {
            id
            name
            details
            emailTimeZone
          }
          subjects {
            id
            name
          }
          studyGroupGeneration {
            id
            startsOn
            endsOn
          }
          availabilities {
            id
            startsAt
            endsAt
            weekday
            weekdayNumber
          }
        }
      }
    }
  }
`

export default OpenGenerationInvites
